import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axiosCommonInstance from '../../../utils/axios/axiosCommonInstance'

const View = () => {
  const { id } = useParams()
  const [metaverse, setMetaverse] = useState(null)
  const [loading, setLoading] = useState(true)

  const fetchMetaverseData = async () => {
    try {
      const response = await axiosCommonInstance.get(`metaverse/detail/${id}`)
      setMetaverse(response.data.result.file)
    } catch (error) {
      console.error('Error fetching metaverse data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchMetaverseData()
  }, [id])

  if (loading) {
    return <div>Loading...</div>
  }

  if (!metaverse) {
    return <div>No metaverse data found.</div>
  }

  const fileUrl = metaverse
  const decodefile = decodeURIComponent(fileUrl)
  return (
    <div style={{ width: '100vw', height: '100vh' }}>
      <iframe
        src={decodefile}
        width='100%'
        height='100%'
        title='Metaverse View'
        style={{ border: '1px solid #ddd',     height: '100vh' }}
      ></iframe>
    </div>
  )
}

export default View
